export default __webpack_public_path__ + "static/media/B0005.254074ac.png";